module.exports = __webpack_public_path__ + "img/32629-102.39b469c4.jpg";